/**
 * Тонкий модуль доступа к текущему access/refresh-токену, НЕ импортирующий
 * authService (и, следовательно, api). Нужен, чтобы разорвать цикл импортов:
 *   api → authStore → authService → api
 * Из-за этого цикла при ESM-инициализации getAuthToken в api.ts оказывался
 * привязанным к ещё не до конца инициализированному authStore → interceptor
 * всегда читал null → /me и прочие запросы уходили без Authorization.
 *
 * authStore прокидывает сюда актуальные значения через setTokens()/clearTokens()
 * при каждом изменении состояния, а api.ts (interceptor) читает их через
 * getAccessToken()/getRefreshToken() — без прямой зависимости от authStore.
 */

let currentTokens: { accessToken?: string | null; refreshToken?: string | null } | null = null;

export function setTokens(tokens: { accessToken?: string | null; refreshToken?: string | null } | null): void {
  currentTokens = tokens;
}

export function clearTokens(): void {
  currentTokens = null;
}

export function getAccessToken(): string | null {
  return currentTokens?.accessToken ?? null;
}

export function getRefreshToken(): string | null {
  return currentTokens?.refreshToken ?? null;
}
